/**
 * Converts common markdown the model streams (bold, italic, inline code, headings, bullets)
 * into safe HTML. The raw text is HTML-escaped first so only the tags we add are introduced,
 * and Angular's sanitizer runs again on the [innerHTML] binding.
 */
export function markdownToHtml(markdown: string): string {
  let html = markdown
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  html = html
    .split('\n')
    .map((line) => {
      const heading = line.match(/^\s*#{1,6}\s+(.*)$/);
      if (heading) {
        return `<strong>${heading[1]}</strong>`;
      }
      const bullet = line.match(/^(\s*)[-*]\s+(.*)$/);
      if (bullet) {
        return `${bullet[1]}• ${bullet[2]}`;
      }
      return line;
    })
    .join('\n');

  html = html
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/__([^_]+)__/g, '<strong>$1</strong>')
    .replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>')
    .replace(/`([^`]+)`/g, '<code>$1</code>');

  return html;
}
